import ExtendableError from '../lib/ExtendableError';

export class AccountRailcardSubmissionError extends ExtendableError { name = 'AccountRailcardSubmissionError'; }
